import { render, staticRenderFns } from "./contractStudentInfo.pug?vue&type=template&id=687b4eda&lang=pug&"
import script from "./contractStudentInfo.ts?vue&type=script&lang=ts&"
export * from "./contractStudentInfo.ts?vue&type=script&lang=ts&"
import style0 from "./contractStudentInfo.styl?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports